<template>
  <bita-modal
    id="edit-modal"
    :title="title"
    :modal-lg="true"
    :is-loading="isLoading"
    @close="reset()"
  >
    <div slot="body">
      <bita-form ref="form">
        <div slot="body">
          <div class="row">
            <bita-input
              type="text"
              name="name"
              label="نام"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="form.name"
            />
            <bita-select
              name="country"
              label="کشور"
              rules=""
              ref="countrySelect"
              :validation-container-class="colWidth"
              input-class="form-control"
              :data-source="countries"
              data-text-field="name"
              data-value-field="id"
              v-model="form.country_id"
            />
            <bita-input
              type="text"
              name="website"
              label="وبسایت"
              rules=""
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="form.website"
            />
            <bita-uploader
              name="icon"
              label="تصویر"
              ref="uploader"
              rules="size:50"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="form.icon"
              :icon-url="form.icon_url"
            />
          </div>
          <bita-formgroup title="سئو" class="row" style="margin-top:30px">
            <bita-input
              type="text"
              name="title"
              label="عنوان"
              rules=""
              :validation-container-class="largeColWidth"
              input-class="form-control"
              v-model="form.title_seo"
            />
            <bita-textarea
              type="text"
              name="title"
              label="توضیحات"
              rules=""
              :validation-container-class="largeColWidth"
              input-class="form-control"
              v-model="form.description_seo"
            />
            <!-- <bita-input
              type="text"
              name="canonical"
              label="کنونیکال"
              rules=""
              :validation-container-class="largeColWidth"
              input-class="form-control"
              v-model="form.canonical"
            /> -->
            <bita-typeahead
              type="text"
              name="name"
              label="کلمه های کلیدی"
              :validation-container-class="largeColWidth"
              input-class="form-control"
              :data-source="matches"
              v-model="tags"
              @on-search="(e) => loadDataSource(e)"
            />
          </bita-formgroup>
        </div>
      </bita-form>
    </div>
    <div slot="footer">
      <bita-bootbutton
        v-if="!form.id"
        type="primary"
        title="ذخیره"
        icon="fas fa-save"
        btn-width="150px"
        @click.native="save"
      />
      <bita-bootbutton
        v-else
        title="بروزرسانی"
        type="primary"
        icon="fas fa-save"
        btn-width="150px"
        @click.native="update"
      />
    </div>
  </bita-modal>
</template>
<script>
export default {
  props: {
    title: String,
    isLoading: Boolean,
    countries: Array,
  },
  data() {
    return {
      colWidth: "col-lg-4",
      largeColWidth: "col-lg-12",
      form: {},
      tags: [],
      matches: [],
    };
  },
  computed: {
    formRef() {
      return this.$refs.form;
    },
  },
  methods: {
    setForm(data) {
      this.form = {
        ...data,
        title_seo: data?.seo?.title,
        description_seo: data?.seo?.description,
        canonical: data?.seo?.canonical,
      };
      this.tags = data.tag_names || [];
    },
    save() {
      this.$refs.form.validate().then((result) => {
        if (result) {
          var newData = this.$getFormData({
            ...this.form,
            tags: this.tags.join(","),
          });
          this.$emit("on-create", newData);
        }
      });
    },
    loadDataSource(tag) {
      tagApi.findTags({ tag: tag }).then((res) => {
        this.matches = collect(res.data.entity)
          .pluck("name.fa")
          .toArray();
      });
    },
    update() {
      this.$refs.form.validate().then((result) => {
        if (result) {
          var newData = this.$getFormData({
            ...this.form,
            tags: this.tags.join(","),
          });
          this.$emit("on-update", newData);
        }
      });
    },
    reset() {
      this.form = {};
      this.$refs.uploader.reset();
      this.$refs.countrySelect.emptyKendo();
      this.formRef.reset();
    },
    setErrors(_errors) {
      this.$refs.form.setErrors(_errors);
    },
  },
};
</script>
